import { StyledContentBackground } from 'components/content-full-screen/content-full-screen';

import { ClientsViewForm } from './Clients-view-form';

export const ClientsView = () => {
  return (
    <StyledContentBackground>
      <>
        {/* <Spin >
                    <ContentTopBar
                        title={''}
                        hasBackButton={''}
                    /> */}

        <StyledContentBackground>
          <ClientsViewForm />
        </StyledContentBackground>
        {/* </Spin> */}
      </>
      {/* {isLoadingField ? (
                <Loader />
            ) : isErrorField ? (
                <Result404 />
            ) : (
                <>
                    <Spin >
                        <ContentTopBar
                            title={''}
                            hasBackButton={''}
                        />

                        <StyledContentBackground>
                            <ClientsViewForm
                            />
                        </StyledContentBackground>
                    </Spin>
                </>
            )} */}
    </StyledContentBackground>
  );
};
